import OrganisationsScene from './scenes/OrganisationsScene';

const routes = [
  {
    path: '/organisations',
    component: OrganisationsScene,
    exact: false,
    menuName: 'Organisations',
    hasSomeRights: [
      'ORGANISATIONS.MANAGE.ALL',
      'ORGANISATIONS.MANAGE.ALL.EXCEPTSYSTEMORGS',
      'ORGANISATIONS.READ.ALL',
      'ORGANISATIONS.READ.ALL.EXCEPTSYSTEMORGS',
    ],
    isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/organisations'),
  },
];

export default routes;
